// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Rj4M6","container":"Footer_container__-SR4z"};